var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#44494D",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8001 15.6631L11.9476 10.7564L7.19383 15.6631C7.13919 15.7203 7.08454 15.7661 7.02443 15.8118C6.5982 16.1035 6.02443 16.0577 5.65284 15.6631C5.22661 15.2171 5.22661 14.4908 5.65284 14.0447L11.1771 8.33169C11.2044 8.30309 11.2317 8.28022 11.259 8.25734C11.4558 8.0915 11.6962 8 11.953 8C12.2426 8 12.5213 8.12009 12.7235 8.33741L18.3466 14.0447C18.7728 14.4908 18.7728 15.2171 18.3466 15.6631C18.2919 15.7203 18.2373 15.7661 18.1772 15.8118C17.751 16.1035 17.1717 16.052 16.8001 15.6631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpBox);
export default __webpack_public_path__ + "static/media/ArrowUpBox.c5abaa77.svg";
export { ForwardRef as ReactComponent };